import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Music } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section">
            <Link to="/" className="footer-logo">
              <img 
                src="/Round Logo White.jpg" 
                alt="Back to People" 
                className="footer-logo-img"
              />
              <div className="footer-logo-text">
                <span className="footer-logo-b2p">B2P</span>
                <span className="footer-logo-full">Back to People</span>
              </div>
            </Link>
            <p className="footer-tagline">
              A reunion of humans where you can be yourself, connect with art, 
              music, and authentic community
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Explore</h4>
            <ul className="footer-links">
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/artists">Artists</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/venue-portfolio">Venue Portfolio</Link></li>
            </ul>
          </div>

          {/* Community */}
          <div className="footer-section">
            <h4 className="footer-heading">Community</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/subscribe">Subscribe</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div className="footer-section">
            <h4 className="footer-heading">Connect</h4>
            <div className="footer-social">
              <a href="https://instagram.com/backtopeople" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Instagram">
                <Instagram size={24} />
              </a>
              <a href="mailto:info@backtopeople.com" className="footer-social-link" aria-label="Email">
                <Mail size={24} />
              </a>
              <a href="https://soundcloud.com/backtopeople" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Music">
                <Music size={24} />
              </a>
            </div>
            <p className="footer-text">
              Hosted by Zee<br />
              Events in Queensland, Australia
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-bottom-text">
            &copy; {currentYear} Back to People. All rights reserved.
          </p>
          <p className="footer-philosophy">
            "If we can't respect the earth, how can we respect each other?"
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

